import React, { FC } from 'react';
import { Dictionary, groupBy } from 'lodash';
import { Collapse, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { getColumnSearchProps } from '../../../utils/table';
import { PlanResponseLog } from '../../../config/types';

interface Props {
  logs: PlanResponseLog[],
  middlewareCallback?: (dataSource: any, columns: ColumnsType<any>) => ({
    dataSource: any,
    columns: ColumnsType<any>,
  }),
}

const PlanResponseLogTable: FC<Props> = ({ logs, middlewareCallback }) => {
  if (!logs) return null;

  const planResponseLogKeyedByMsg = groupBy(
    logs,
    'msg',
  ) as unknown as Dictionary<PlanResponseLog[]>;
  return (
    <>
      {
      Object.values(planResponseLogKeyedByMsg).map((l) => {
        const exampleLog = l[0];
        if (!exampleLog) return null;
        let columns: ColumnsType<any> = Object.keys(exampleLog.tags).map(key => ({
          title: key,
          dataIndex: key,
          key,
          ...getColumnSearchProps(key),
          sorter: (a, b) => a[key]?.localeCompare(b[key]),
        }));

        let dataSource: Record<string, string>[] = l.map(groupedLog => ({
          key: JSON.stringify(groupedLog),
          ...groupedLog.tags,
        }));

        const { metadata, msg } = exampleLog;
        const description = metadata?.description || null;
        const title = `${msg} (${(l.length)})${description ? `: ${description}` : ''}`;

        if (middlewareCallback) {
          ({ columns, dataSource } = middlewareCallback(columns, dataSource));
        }

        return (
          <Collapse
            collapsible="header"
            defaultActiveKey={['1']}
            items={[
              {
                key: title,
                label: title,
                children: <Table dataSource={dataSource} columns={columns} pagination={false} />,
              },
            ]}
          />
        );
      })
    }
    </>
  );
};

export default PlanResponseLogTable;
